import { FC } from 'react'

import { IAuthorLector } from '../author-lector/author-lector.types'
interface ICustomLector {
  lecturName?: string
  LectorComponent: FC<IAuthorLector>
}

const CustomLector: FC<ICustomLector> = ({ lecturName, LectorComponent }: ICustomLector) => {
  let lectors: string[] = []
  if (lecturName) lectors = lecturName.split(',')

  return (
    <>
      {Boolean(lectors.length) &&
        lectors.map((lector) => {
          const splittedName = lector.split(' ').filter((item) => item)
          const lectorName = {
            lastName: splittedName[0] || '',
            firstName: splittedName[1] || '',
            secondName: splittedName[2] || '',
          }
          const lectorData = { ...lectorName, id: 0, small: true }

          return <LectorComponent lectorData={lectorData} key={lector} />
        })}
    </>
  )
}

export default CustomLector
